import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "./hooks/useAuth";
import Layout from "./components/Layout";
import Home from "./pages/Home";
import Services from "./pages/Services";
import PaintProtectionFilm from "./pages/services/PaintProtectionFilm";
import CeramicCoatings from "./pages/services/CeramicCoatings";
import WindowTint from "./pages/services/WindowTint";
import VinylWraps from "./pages/services/VinylWraps";
import WindshieldProtection from "./pages/services/WindshieldProtection";
import PPFSummerlin from "./pages/services/PPFSummerlin";
import PPFQuoteLanding from "./pages/PPFQuoteLanding";
import CeramicCoatingHenderson from "./pages/services/CeramicCoatingHenderson";
import TeslaProtection from "./pages/TeslaProtection";
import Gallery from "./pages/Gallery";
import Resources from "./pages/Resources";
import BlogPost from "./pages/resources/BlogPost";
import About from "./pages/About";
import Contact from "./pages/Contact";
import Admin from "./pages/admin/Admin";
import GalleryManagement from "./pages/admin/GalleryManagement";
import Submissions from "./pages/admin/Submissions";
import TestimonialManagement from "./pages/admin/TestimonialManagement";
import VideoManagement from "./pages/admin/VideoManagement";
import NotFound from "./pages/NotFound";

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <Toaster />
      <Sonner />
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            <Route path="/" element={<Layout />}>
              <Route index element={<Home />} />
              <Route path="services" element={<Services />} />
              <Route path="services/paint-protection-film" element={<PaintProtectionFilm />} />
              <Route path="services/ceramic-coatings" element={<CeramicCoatings />} />
              <Route path="services/window-tint" element={<WindowTint />} />
              <Route path="services/vinyl-wraps" element={<VinylWraps />} />
              <Route path="services/windshield-protection" element={<WindshieldProtection />} />
              <Route path="services/window-tint-wraps" element={<Navigate to="/services/window-tint" replace />} />
              <Route path="ppf-in-summerlin" element={<PPFSummerlin />} />
              <Route path="ceramic-coating-henderson" element={<CeramicCoatingHenderson />} />
              <Route path="tesla-protection" element={<TeslaProtection />} />
              <Route path="ppf-quote" element={<PPFQuoteLanding />} />
              <Route path="gallery" element={<Gallery />} />
              <Route path="resources" element={<Resources />} />
              <Route path="resources/:slug" element={<BlogPost />} />
              <Route path="about" element={<About />} />
              <Route path="contact" element={<Contact />} />
              <Route path="*" element={<NotFound />} />
            </Route>
              <Route path="/admin" element={<Admin />} />
              <Route path="/admin/gallery" element={<GalleryManagement />} />
              <Route path="/admin/submissions" element={<Submissions />} />
              <Route path="/admin/testimonials" element={<TestimonialManagement />} />
              <Route path="/admin/videos" element={<VideoManagement />} />
          </Routes>
        </AuthProvider>
      </BrowserRouter>
    </TooltipProvider>
  </QueryClientProvider>
);

export default App;
